import { render, staticRenderFns } from "./exchange-detail.vue?vue&type=template&id=02fe82c8&scoped=true&"
import script from "./exchange-detail.vue?vue&type=script&lang=js&"
export * from "./exchange-detail.vue?vue&type=script&lang=js&"
import style0 from "./exchange-detail.vue?vue&type=style&index=0&id=02fe82c8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02fe82c8",
  null
  
)

component.options.__file = "exchange-detail.vue"
export default component.exports